import { useState, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./TradeCard.css";
import { Link } from "react-router-dom"

export default function TradeCard() {
  const [copyExperts, setCopyExperts] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchCopytrade: true })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data)
      // if (data.status === "success") {
      //   setWallet(data.wallet);
      // }
    })
    .catch(err => {
    })
  }, []);
  return (
    <div className="tradecard-section container">
      <h2 className="fw-bold mb-5">Copy Trades. Easy. Smart</h2>
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        slidesPerView={4}
        spaceBetween={24}
        slidesPerGroup={4}
        loop={copyExperts.length > 4}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        breakpoints={{
          1200: { slidesPerView: 4, slidesPerGroup: 4 },
          900: { slidesPerView: 2, slidesPerGroup: 2 },
          0: { slidesPerView: 1, slidesPerGroup: 1 },
        }}
        className="tradecard-swiper"
      >
        {copyExperts.map((expert, idx) => (
          <SwiperSlide key={idx}>
            <div className="tradecard-card">
              <div className="tradecard-header">
                <img
                  src={`/uploads/${expert.trader_photo}`}
                  alt={expert.trader_photo}
                  className="tradecard-avatar"
                />
                <span className="tradecard-name">{expert.trader_name}</span>
              </div>
              <div className="tradecard-info">
                <div className="tradecard-label mb-2">{expert.win} Won Trade</div>
                <div className="tradecard-roi">{expert.win_rate}</div>
                <div className="tradecard-label">WIN RATE</div>
                <div
                  className="tradecard-pnl"
                  style={{ color: "#00ff99" }}
                >
                  Profit Share {expert.profit_share}
                </div>
              </div>
              <Link to="/login" className="tradecard-copy">Copy</Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}